import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-final-form';
import GiftAidQuestion from '../../../../../02_molecules/GiftAidQuestion';
import keyboardFocusWithinElement from '../../../../../../utils/keyboardFocusWithinElement';

import styles from './index.module.scss';

const GiftAidPopup = ({ continuePayment = null, setGiftAidVisible, isGiftAidSubmitted, style }) => {
  const form = useForm();

  // Block scrolling of page.
  useEffect(() => {
    document.body.classList.add('with-popup');
    return () => document.body.classList.remove('with-popup');
  }, []);

  // Keep keyboard navigation within Giftaid popup.
  useEffect(() => {
    const keepKeyboardNavigationWithinGiftAidPopup = (e) => {
      keyboardFocusWithinElement(e, '#giftaid-popup');
    };
    const element = document.getElementById('giftaid-popup');
    if (element) {
      // Focus the first link in the GiftAid popup.
      element.querySelectorAll('a')[0].focus();
    }
    window.addEventListener('keydown', keepKeyboardNavigationWithinGiftAidPopup);
    return () => {
      window.removeEventListener('keydown', keepKeyboardNavigationWithinGiftAidPopup);
    };
  }, []);

  return (
    <div className={styles['giftaid']} id="giftaid-popup">
      <GiftAidQuestion
        onCancel={() => {
          form.mutators.setValue('gift_aid', false);
          isGiftAidSubmitted.current = true;
          setGiftAidVisible(false);
          if (continuePayment) {
            continuePayment();
          } else {
            form.submit();
          }
        }}
        onAccept={() => {
          form.mutators.setValue('gift_aid', true);
          isGiftAidSubmitted.current = true;
          setGiftAidVisible(false);
          if (continuePayment) {
            continuePayment();
          } else {
            form.submit();
          }
        }}
        heading="Increase the value of my donation by 25% at no extra cost"
        variant="inline-donation-form"
        buttonType={style === 'emergency' ? 'emergency' : 'primary'}
      />
    </div>
  );
};

GiftAidPopup.propTypes = {
  continuePayment: PropTypes.func,
  setGiftAidVisible: PropTypes.func.isRequired,
  isGiftAidSubmitted: PropTypes.object.isRequired,
  style: PropTypes.oneOf(['default', 'emergency']).isRequired,
};

export default GiftAidPopup;
